import { z } from 'zod';
import { IS_REQUIRED } from '@occc-app/lib/constants/validationMessages';
import { Offer_Activation_Operator } from '@occc/graphql';

export const offerActivationSchema = z
  .array(
    z.object({
      operator: z.nativeEnum(Offer_Activation_Operator),
      targetOffer: z.object({}).passthrough().optional().nullable(),
    }),
  )
  .superRefine((items, ctx) => {
    const hasAnyTargetOffer = items.some(
      ({ targetOffer }) => targetOffer && Object.keys(targetOffer).length > 0,
    );

    if (!hasAnyTargetOffer) {
      return;
    }

    items.forEach((item, index) => {
      const hasTargetOffer = item.targetOffer && Object.keys(item.targetOffer).length > 0;
      if (!hasTargetOffer) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: [index, 'targetOffer'],
          message: IS_REQUIRED,
        });
      }
    });
  });
